import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n  ", ";\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from "styled-components";
import { text } from "../../Utils/Constants";

var InputMessage = function InputMessage(props) {
  return React.createElement(StyledInputMessage, props, props.children);
};

export default InputMessage;
export var StyledInputMessage = styled.p(_templateObject(), function (props) {
  return props.theme.color('text', 'primary');
}, text("text", "s"), function (props) {
  return props.valid && css(_templateObject2(), props.theme.color('action', 'success'));
}, function (props) {
  return props.error && css(_templateObject3(), props.theme.color('action', 'danger'));
});